import { render, staticRenderFns } from "./giveHand.vue?vue&type=template&id=536c0fc7&scoped=true"
import script from "./giveHand.vue?vue&type=script&lang=js"
export * from "./giveHand.vue?vue&type=script&lang=js"
import style0 from "./giveHand.vue?vue&type=style&index=0&id=536c0fc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c0fc7",
  null
  
)

export default component.exports